import { type UseFormSetError, type Path } from 'react-hook-form';

// Generic function to handle API errors and map them to form fields
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setFormErrors<T extends Record<string, any>>(
  apiErrors: Record<string, string | string[]>,
  setError: UseFormSetError<T>,
  data: T
) {
  Object.keys(apiErrors).forEach((field) => {
    // Convert API field name (e.g., EndDate) to form field name (e.g., endDate)
    const fieldName = field.charAt(0).toLowerCase() + field.slice(1);

    // Check if the field exists in the form data
    if (fieldName in data) {
      // Ensure fieldName is treated as a valid Path<T>
      const validFieldName = fieldName as Path<T>;

      // Handle both single string errors and array of errors
      const errorMessage = Array.isArray(apiErrors[field])
        ? (apiErrors[field] as string[])[0]
        : apiErrors[field] as string;

      setError(validFieldName, {
        type: 'server',
        message: errorMessage,
      });
    } else {
      // Handle non-field-specific errors using 'root'
      const errorMessage = Array.isArray(apiErrors[field])
        ? (apiErrors[field] as string[])[0]
        : apiErrors[field] as string;

      setError('root', {
        type: 'server',
        message: errorMessage,
      });
    }
  });
}